<script setup lang="ts">
import LoginForm from './LoginForm.vue';
</script>

<template>
  <div class="flex min-h-screen bg-[#0A0A0B] items-center justify-center p-6">
    <div class="w-full max-w-md">
      <!-- Logo/Brand Section -->
      <div class="mb-8 flex flex-col items-center text-center">
        <img src="@/assets/images/logo-dark.png" alt="Assistly" class="h-20 object-contain mb-4" />
        <p class="text-[#9E9080] italic text-xs">
          {{ $t('login_screen.tagline') }}
        </p>
      </div>

      <!-- Login Form -->
      <LoginForm />
    </div>
  </div>
</template>
